export const circlePeri = radius => 2 * Math.PI * radius;
export const percentPeri = (radius, percent) => circlePeri(radius) - (circlePeri(radius) * (percent / 100));
